import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "../../context/ThemeContext"; // Import theme context

export default function SidebarItem({
  label,
  panic = false,
  expandable = false,
  isOpen = false,
  onClick,
  children,
}) {
  const { theme } = useTheme();

  // Theme-based styling
  const containerStyling = theme === 'dark' 
    ? {
        openBg: 'bg-slate-800/90 border-slate-600',
        shadow: 'shadow-[0_10px_20px_-5px_rgba(0,0,0,0.3)]'
      }
    : {
        openBg: 'bg-white border-white/30', 
        shadow: 'shadow-[0_10px_20px_-5px_rgba(255,255,255,0.2)]'
      };

  const buttonStyling = theme === 'dark'
    ? {
        closed: 'text-slate-200 hover:bg-slate-700/50 hover:text-emerald-300',
        open: 'bg-slate-800/90 text-slate-200',
        panic: 'bg-slate-800 text-emerald-400 border border-emerald-500/50'
      }
    : {
        closed: 'text-white hover:bg-white/20 hover:text-white',
        open: 'bg-white text-emerald-700',
        panic: 'bg-white text-emerald-600 border border-white/30'
      };

  const iconStyling = theme === 'dark'
    ? {
        closed: 'bg-slate-600 text-slate-200',
        open: 'bg-slate-700 text-slate-200'
      }
    : {
        closed: 'bg-white/30 text-white',
        open: 'bg-emerald-600 text-white'
      };

  const hrColor = theme === 'dark' ? 'border-slate-600' : 'border-emerald-600';
  const childrenBg = theme === 'dark' ? 'bg-slate-800/90' : 'bg-white';

  return (
    <div
      className={`transition-all duration-300 ease-in-out ${
        isOpen
          ? `${containerStyling.shadow} ${containerStyling.openBg} border rounded-xl`
          : "shadow-none"
      }`}
    >
      <div
        onClick={onClick}
        className={`group flex items-center cursor-pointer px-3 py-2 text-sm font-bold transition-colors h-11 ${
          panic
            ? `${buttonStyling.panic} rounded-2xl justify-center mx-4`
            : `${isOpen ? buttonStyling.open : buttonStyling.closed} justify-between rounded-xl`
        }`}
      >
        <span>{label}</span>
        {expandable && (
          <div className={`rounded-full transition-colors ${
            isOpen ? iconStyling.open : iconStyling.closed
          }`}>
            {isOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </div>
        )}
      </div>

      {expandable && isOpen && (
        <hr className={`${hrColor} mt-0 border-t-2`} />
      )}

      {expandable && (
        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden rounded-lg ${
            isOpen
              ? `max-h-96 opacity-100 ${childrenBg}`
              : "max-h-0 opacity-0"
          }`}
        >
          {children}
        </div>
      )}
    </div>
  );
}